import { render, staticRenderFns } from "./MaintainStockForm.vue?vue&type=template&id=24bdfa42&scoped=true"
import script from "./MaintainStockForm.vue?vue&type=script&lang=js"
export * from "./MaintainStockForm.vue?vue&type=script&lang=js"
import style0 from "./MaintainStockForm.vue?vue&type=style&index=0&id=24bdfa42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bdfa42",
  null
  
)

export default component.exports